import React from 'react';
import { useTranslation } from 'react-i18next';
import TPTypography from 'components/TP-UI/TPTypography';
import PropTypes from 'prop-types';
import CySecDisclaimer from '../CySecDisclaimer';

const Disclaimer = ({ documents, textKey, isCyHub }) => {
  const { t } = useTranslation('auth');

  return isCyHub ? (
    <CySecDisclaimer documents={documents} textKey={textKey} />
  ) : (
    t(textKey)
      .split('\n')
      .map((line, key) => (
        <TPTypography variant="body3" color="secondary" key={key}>
          {line}
        </TPTypography>
      ))
  );
};

Disclaimer.propTypes = {
  documents: PropTypes.object,
  textKey: PropTypes.string,
  isCyHub: PropTypes.bool,
};

export default Disclaimer;
